var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('AppHeader'),_c('div',{staticClass:"app-body"},[_c('main',{staticClass:"main h-100"},[_c('router-view',{key:_vm.$route.path})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }